import type { Logout } from 'flowhawk-core';
import type { Reducer } from '@reduxjs/toolkit';
import type { ResetData } from './ApplicationActions';

export type RecipientUploadError = {
  field: string;
  message: string;
};

export type RecipientUpload = {
  mime: string;
  size: number;
  path: string;
  file: File;
  fileName: string;
  displayName?: string;
};

export type RecipientUploadState = {
  recipientUpload?: RecipientUpload;

  errors?: Array<RecipientUploadError>;
};

const initialState: RecipientUploadState = {
  recipientUpload: undefined,
  errors: undefined,
};

export type StartRecipientUpload = { type: 'RecipientUpload/START_UPLOAD'; recipientUpload: RecipientUpload };
export type SetRecipientUploadError = { type: 'RecipientUpload/SET_ERRORS'; errors?: Array<RecipientUploadError> };

type Action = StartRecipientUpload | SetRecipientUploadError | ResetData | Logout;

export const startRecipientUpload = (recipientUpload: RecipientUpload) => ({
  type: 'RecipientUpload/START_UPLOAD',
  recipientUpload,
});

export const setRecipientUploadError = (errors?: Array<RecipientUploadError>) => ({
  type: 'RecipientUpload/SET_ERRORS',
  errors,
});

const reducer = (state: RecipientUploadState = initialState, action: Action): RecipientUploadState => {
  switch (action.type) {
    case 'Application/RESET_DATA':
    case 'Auth/LOGOUT':
      // Reset the store when logging out
      return {
        ...initialState,
      };

    case 'RecipientUpload/SET_ERRORS':
      return {
        ...state,
        errors: action.errors,
      };

    default:
      return state;
  }
};

export default reducer as Reducer<RecipientUploadState>;
